import React, { useEffect, useRef, useState } from "react";
import { CutFunctionsProp } from "bodycodi/cmap/app/components/common/imageEditor/imageEditer";

import freeCutOff from "bodycodi/cmap/app/img/free-cut-off.png";
import freeCutOn from "bodycodi/cmap/app/img/free-cut-on.png";
import oneCutOn from "bodycodi/cmap/app/img/1-cut-on.png";
import oneCutOff from "bodycodi/cmap/app/img/1-cut-off.png";
import nineCutOff from "bodycodi/cmap/app/img/9-cut-off.png";
import nineCutOn from "bodycodi/cmap/app/img/9-cut-on.png";
import threeCutOn from "bodycodi/cmap/app/img/3-cut-on.png";
import threeCutOff from "bodycodi/cmap/app/img/3-cut-off.png";
import fourCutOff from "bodycodi/cmap/app/svg/4-cut-off.svg";
import fourCutOn from "bodycodi/cmap/app/svg/4-cut-on.svg";
import originalOn from "bodycodi/cmap/app/img/original-on.png";
import originalOff from "bodycodi/cmap/app/img/original-off.png";

const CutControll = ({ editor, setMode }: CutFunctionsProp) => {
  const [cropRatio, setCropRatio] = useState("o");
  const [tip, setTip] = useState<boolean>(false);
  const wrap = useRef<HTMLDivElement>(null);

  useEffect(() => {
    wrap.current?.classList.add("open");
  }, []);

  const clickCropRatio = (i: string) => () => {
    if (i === "o") {
      editor.setCropzoneRect(editor.getCanvasSize().width / editor.getCanvasSize().height);
      setTip(false);
    } else if (i === "f") {
      setTip(true);
      editor.setCropzoneRect(0);
    } else if (i === "1") {
      setTip(false);
      editor.setCropzoneRect(1);
    } else if (i === "9") {
      setTip(false);
      editor.setCropzoneRect(9 / 16);
    } else if (i === "4") {
      setTip(false);
      editor.setCropzoneRect(4 / 3);
    } else if (i === "3") {
      setTip(false);
      editor.setCropzoneRect(3 / 4);
    }
    setCropRatio(i);
  };

  const close = () => {
    wrap.current?.classList.remove("open");
    wrap.current?.classList.add("close");
    editor.stopDrawingMode();
    setTimeout(() => {
      setMode("");
    }, 100);
  };

  const clicConfirm = () => {
    editor.crop(editor.getCropzoneRect()).then(function () {
      editor.stopDrawingMode();
      close();
    });
  };

  return (
    <div className="custon-editor-feature-detail-wrap" ref={wrap}>
      <div className="custon-editor-feature-detail">
        <div className={"btn" + (cropRatio === "o" ? " active" : "")} onClick={clickCropRatio("o")}>
          <div className="ratioImg">
            {cropRatio === "o" && <img src={originalOn} />}
            {cropRatio !== "o" && <img src={originalOff} />}
          </div>
          <div className="text">원본</div>
        </div>
        <div className={"btn" + (cropRatio === "f" ? " active" : "")} onClick={clickCropRatio("f")}>
          <Tip open={tip} setOpen={setTip} />
          <div className="ratioImg">
            {cropRatio === "f" && <img src={freeCutOn} />}
            {cropRatio !== "f" && <img src={freeCutOff} />}
          </div>
          <div className="text">자유롭게</div>
        </div>
        <div className={"btn" + (cropRatio === "1" ? " active" : "")} onClick={clickCropRatio("1")}>
          <div className="ratioImg">
            {cropRatio === "1" && <img src={oneCutOn} />}
            {cropRatio !== "1" && <img src={oneCutOff} />}
          </div>
          <div className="text">1 : 1</div>
        </div>
        <div className={"btn" + (cropRatio === "3" ? " active" : "")} onClick={clickCropRatio("3")}>
          <div className="ratioImg">
            {cropRatio === "3" && <img src={nineCutOn} />}
            {cropRatio !== "3" && <img src={nineCutOff} />}
          </div>
          <div className="text">3 : 4</div>
        </div>
        <div className={"btn" + (cropRatio === "9" ? " active" : "")} onClick={clickCropRatio("9")}>
          <div className="ratioImg">
            {cropRatio === "9" && <img src={threeCutOn} />}
            {cropRatio !== "9" && <img src={threeCutOff} />}
          </div>
          <div className="text">9 : 16</div>
        </div>
        <div className={"btn" + (cropRatio === "4" ? " active" : "")} onClick={clickCropRatio("4")}>
          <div className="ratioImg">
            {cropRatio === "4" && <img src={fourCutOn} />}
            {cropRatio !== "4" && <img src={fourCutOff} />}
          </div>
          <div className="text">4 : 3</div>
        </div>
      </div>
    </div>
  );
};

type tip = {
  open: boolean;
  setOpen: Function;
};

const Tip = ({ open, setOpen }: tip) => {
  useEffect(() => {}, [open]);

  return (
    <>
      {open && (
        <div className="cut-freestyle-tip open">
          원하는 영역을 <br />
          <span>드래그 해주세요!</span>
        </div>
      )}
    </>
  );
};
export default CutControll;
